<h5>{{ "Template.AutoApproveComponent.subHeader_dataAccess" | translate }}</h5>
<h6>{{ "Template.AutoApproveComponent.subHeader_autoOrManual" | translate }}</h6>

<form class="form-group" novalidate [formGroup]="form">
  <div class="form-check">
    <input class="form-check-input" type="radio" formControlName="autoApprove" id="isTrue" [value]="true" />
    <label class="form-check-label text-success" for="isTrue">{{ "Template.AutoApproveComponent.label_autoApproveAll" | translate }}</label>
  </div>
  <div class="form-check mt-3">
    <input class="form-check-input" type="radio" formControlName="autoApprove" id="isFalse" [value]="false" />
    <label class="form-check-label text-danger" for="isFalse">{{ "Template.AutoApproveComponent.label_approveOnRequest" | translate }}</label>
  </div>

  @if (form.dirty) {
    <button class="btn btn-success btn-sm btn-block px-3 mt-2" type="button" (click)="save()">
      <fa-icon icon="check" class="me-1"></fa-icon>
      {{ "Template.AutoApproveComponent.btn_save" | translate }}
      @if (saving) {
        <fa-icon icon="spinner" animation="spin" class="ms-1"></fa-icon>
      }
    </button>
  }
</form>
